import { cva, type VariantProps } from 'class-variance-authority';

/**
 * InsightCard container: tinted surface + border aligned with DataPoint / info-card tokens.
 */
export const insightCardVariants = cva(
  'rounded-md border w-full px-info-card-sides py-info-card-top-bottom',
  {
    variants: {
      style: {
        primary: 'bg-primary-50 border-primary-700',
        secondary: 'bg-secondary-50 border-secondary-700',
        neutral: 'bg-neutral-50 border-neutral-200',
      },
    },
    defaultVariants: {
      style: 'primary',
    },
  },
);

export type InsightCardVariantProps = VariantProps<typeof insightCardVariants>;
